module.exports = __webpack_public_path__ + "img/1Tlaxcala_02.6438ce1f.png";